<div class="page-layout simple left-sidebar inner-sidebar inner-scroll">
    <!-- HEADER -->
    <div class="header accent p-6 flex items-center">
        <div>
            <span class="text-4xl font-semibold">Administración de ICC</span>
        </div>
    </div>
    <!-- / HEADER -->
    <!-- CONTENIDO PRINCIPAL -->
    <div class="content flex">
        <!-- SIDEBAR -->
        <div class="sidebar p-6 overflow-y-auto">
            <entity-list
                #entityList
                title="Lista de ICC"
                [values]="iccList"
                (entitySelected)="selected($event)">
            </entity-list>
        </div>
        <!-- / SIDEBAR -->
        <div class="w-px bg-gray-200"></div>
        <!-- CONTENIDO CENTRAL -->
        <div class="center flex flex-col p-6 flex-grow">
            <span class="text-3xl font-semibold mb-4">Datos de ICC</span>
            <div *ngIf="_systemService.canAction('adminClients')" class="pb-4 w-[600px] flex justify-end">
                <button (click)="newICC()" class="flex items-center gap-2 bg-blue-500 text-white py-2 px-4 rounded">
                    <mat-icon>add</mat-icon>
                    <span>Nuevo</span>
                </button>
            </div>
            <div class="content p-6">
                <app-icc #iccForm (entityChanged)="entityChanged($event)"></app-icc>
            </div>
        </div>
    </div>
</div>

